
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d)"}},[_c('path',{attrs:{"d":"M9.81 19.31c-.3 0-.45-.15-.45-.45v-5.04c0-.06-.03-.1-.09-.13-.03-.03-.07-.03-.13 0l-4.6 2.65a.5.5 0 01-.22.05.44.44 0 01-.4-.23l-.86-1.53a.5.5 0 01-.04-.22c0-.18.07-.32.22-.4l4.63-2.53c.06-.03.1-.07.1-.13s-.04-.1-.1-.14L3.25 8.7a.4.4 0 01-.23-.27.5.5 0 01.05-.36l.85-1.53a.4.4 0 01.27-.22.5.5 0 01.37.04l4.58 2.61c.06.03.11.03.14 0 .06-.03.09-.07.09-.13v-5c0-.3.15-.45.45-.45h1.71c.3 0 .45.15.45.45v5c0 .06.01.1.04.13a.2.2 0 00.19 0l4.59-2.6a.5.5 0 01.2-.07c.18 0 .31.07.4.22l.82 1.53a.5.5 0 01.04.23c0 .18-.07.31-.22.4L13.4 11.2a.15.15 0 00-.09.14c0 .06.03.1.09.13L18.05 14c.11.06.19.15.22.27a.5.5 0 01-.04.36l-.82 1.53a.4.4 0 01-.27.23.5.5 0 01-.36-.05L12.2 13.7a.2.2 0 00-.17 0c-.04.03-.05.07-.05.13v5.04c0 .3-.15.45-.45.45H9.81z","fill":"#F9C22E"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d","x":"0","y":".38","width":"21.29","height":"21.93","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"1.5"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.976471 0 0 0 0 0.760784 0 0 0 0 0.180392 0 0 0 1 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    